import { render, staticRenderFns } from "./ProactiveHelpDialog.vue?vue&type=template&id=56b312d5&scoped=true"
import script from "./ProactiveHelpDialog.vue?vue&type=script&lang=js"
export * from "./ProactiveHelpDialog.vue?vue&type=script&lang=js"
import style0 from "./ProactiveHelpDialog.vue?vue&type=style&index=0&id=56b312d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b312d5",
  null
  
)

export default component.exports